import { useCallback } from 'react';
import AnimalType from '../../../../../enums/animal-type';
import { useHistory, useParams } from 'react-router-dom';
import { useService } from '../../../../../services/services';
import { SubmitType } from '../../../../../components/form';
import { WeighingFormData } from '../../../../../interfaces/animal-event';
import { route } from '../../../../../services/utils';
import { LIVESTOCK_ANIMALS_WEIGHING_VIEW } from '../../../../../router/routes';
import { FormMode } from '../../../../../enums/form-mode';
import { useQuery } from '../../../../../hooks/use-query';

export function useWeighingUpdate() {
  const { farmId, id } = useParams<{
    farmId: string;
    id: string;
  }>();

  const history = useHistory();
  const { animalEventService } = useService();
  const [queries] = useQuery();

  return useCallback<SubmitType<any>>(
    (data) => {
      const formData: WeighingFormData = {
        type: AnimalType.weighing,
        status: data.status,
        animals: data.weighingsAndAnimals.map((item) => ({
          id: item.animalId,
          animal_event_animal_id: item.animal_event_animal_id,
          births_weight: item.births_weight,
          weight_type: item.weight_type.value,
          weight: item.weight,
          breast_circumference: item.breast_circumference,
          neck_height: item.neck_height,
          lower_back_height: item.lower_back_height,
          modified_weigth: item.modified_weigth,
        })),
        date: data.date,
        notes: data.notes,
        file_id: data.file && data.file.length > 0 ? data.file[0].id : null,
        purpose_and_place_of_use: null,
      };

      return [
        animalEventService.update(farmId, id, formData),
        (response) => {
          history.push(
            route(
              `${LIVESTOCK_ANIMALS_WEIGHING_VIEW}${
                queries.to ? '?to='.concat(queries.to) : ''
              }`,
              {
                farmId,
                id: response.data.id,
                mode: FormMode.view,
              }
            )
          );
        },
      ];
    },
    [animalEventService, farmId, history, id, queries.to]
  );
}
